<template>
  <!-- 新增商品 -->
  <h-dialog
    :title="$t('orderModules.exceptionOrder.addGoods')"
    v-model="isShow"
    :confirmLoading="loading"
    @onOk="ok"
    @onCancel="cancel"
    width="1000px"
    align-center
  >
    <h-table
      ref="tableRef"
      vuexNamespace="choose-checkbox-goods"
      :http="getList"
      :columns="columns"
      :queryForm="queryForm"
      row-key="id"
      id="model-choose-shop"
      @selection-change="selectionChange"
    >
      <template #formFn>
        <el-link type="primary" v-if="$t('common.mode') == 'zh-cn'">
          已选择 {{ selectedItem.length }} 项
        </el-link>
        <el-link type="primary" v-else>
          Selected({{ selectedItem.length }})
        </el-link>
      </template>
      <template #logo_url="{row}">
        <el-image
          :src="row.logo_url"
          :preview-src-list="[row.logo_url]"
          style="cursor: pointer; width: auto; height: 25px"
          preview-teleported
          fit="fill"
        />
      </template>
      <template #bar_code_list="{ row:{bar_code_list=[]} }">
        <span v-if="bar_code_list.length === 1">{{ bar_code_list[0] }}</span>
        <el-tooltip
          v-else-if="bar_code_list.length > 1"
          raw-content
          :content="bar_code_list.join('<br/>')"
          placement="top"
          trigger="click"
        >
          <el-link type="primary">{{ $t('orderModules.salesOrder.viewCode') }}</el-link>
        </el-tooltip>
        <div v-else>--</div>
      </template>
    </h-table>
  </h-dialog>
</template>

<script setup>
import { ref, unref, watch } from 'vue'
import { getGlobalData } from '@/core/global-data'

import { np_divide } from '@/utils/tools'
import { goodsList } from '@/api/goods-manager/commercial-goods'
import { $t } from '@/i18n'

const props = defineProps({
  alreadySelected: {
    type: Array,
    required: true
  }
})

const isShow = ref(false)

const loading = ref(false)

const emits = defineEmits(['sendGoods'])
const ok = () => {
  emits('sendGoods', unref(selectedItem))
  tableRef.value.tableFn(`clearSelection`)
  isShow.value = false
}

const cancel = () => {
  tableRef.value.tableFn(`clearSelection`)
}

const columns = [
  {
    minWidth: 60,
    fixed: 'left',
    type: 'selection',
    reserveSelection: true
  },
  {
    prop: 'logo_url',
    label: $t('orderModules.exceptionOrder.goodsImg'),
    minWidth: 100,
    scopedSlots: `logo_url`
  },
  {
    prop: 'brand_name',
    label: $t('productModules.merchantGoods.brand'),
    minWidth: 150,
    showOverflowTooltip: true,
    formatter: (row, column, text) => {
      return text || `--`
    }
  },
  {
    prop: 'name',
    label: $t('home.ranking.goodsName'),
    minWidth: 160,
    showOverflowTooltip: true
  },
  {
    prop: 'bar_code_list',
    label: $t('orderModules.salesOrder.goodsCode'),
    minWidth: 160,
    showOverflowTooltip: true,
    scopedSlots: 'bar_code_list'
  }
]

const queryForm = {
  formItems: [
    {
      key: 'name',
      label:$t('home.ranking.goodsName'),
      type: 'input',
      placeholder: $t('common.pleaseInput')
    },
    {
      prop: 'country_code',
      label: $t('productModules.merchantGoods.countryOfOrigin'),
      minWidth: 100,
      showOverflowTooltip: true,
      formatter: () => getGlobalData('country_code') || '--'
    },
    {
      key: 'code',
      label: $t('orderModules.salesOrder.goodsCode'),
      type: 'input',
      placeholder: $t('common.pleaseInput')
    }
  ]
}

const tableRef = ref()

const selectedItem = ref([])

/* 多选筛选 */
const selectionChange = (selection) => {
  selectedItem.value = selection
  //   console.log(`===> `, selectedItem);
}

const getList = (params) => {
  params.enabled = 1
  return goodsList(params)
}

watch(() => isShow.value, () => {
  if (isShow.value) {
    console.log(props.alreadySelected)
    props.alreadySelected.forEach(v => {
      tableRef.value && tableRef.value?.tableFn(`toggleRowSelection`, v, true)
    })
  }
})

defineExpose({
  isShow
})
</script>

<style lang="scss" scoped>
#model-choose-shop :deep(form > div > div) {
  flex: 0.6 !important;
  max-width: none;
}

:deep(.x-form) {
  padding-top: 0 !important;
}
</style>
